import React from "react";
import { motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";
import Navbar from "./Navbar";
import { useLanguage } from "../i18n";

const Home = () => {
  const { t } = useLanguage();
  const scrollToContact = (event) => {
    event.preventDefault();
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="home-container">
      <Navbar />
      <div className="home-banner-container" id="home">
        <motion.div
          className="home-text-section"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7 }}
        >
          <p className="eyebrow">{t.heroEyebrow}</p>
          <h1 className="hero-heading">
            {t.heroTitle.split("|")[0]}
            <br />
            {t.heroTitle.split("|")[1]}
          </h1>
          <p className="primary-text">
            {t.heroText}
          </p>
          <a href="#contact" onClick={scrollToContact}>
            <motion.button className="secondary-button" whileHover={{ y: -2 }}>
              {t.quote} <FiArrowRight />
            </motion.button>
          </a>
        </motion.div>

      </div>
    </header>
  );
};

export default Home;
